<template>
    <div v-if="!result && !errors" class="mt-24 mx-auto w-1/2">
        <form id="payment-form">
            <div id="payment-element">
                <!-- Stripe will create form elements here -->
            </div>
            <button type="submit" @click="handleSubmit">Pay via Stripe</button>
        </form>
    </div>

    <div v-else>
        <p v-if="result">Payment successful</p>
        <p v-if="errors">{{ errors }}</p>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import route from "ziggy-js";

const paymentIntentId = ref(undefined);
const stripe = ref(undefined);
const elements = ref(undefined);

const result = ref(undefined);
const errors = ref(undefined);

onMounted(() => {
    axios
        .post(
            route("api.payments.store"),
            {},
            {
                headers: {
                    Authorization:
                        "Bearer " + "bINIbfBAOI8YOe5wYfJcwbx58l1Clapt",
                },
            },
        )
        .then((response) => {
            paymentIntentId.value = response.data.data.paymentIntentId;
            stripe.value = Stripe(
                "pk_test_51JsOKHJ9tIQH9YIAUPeVLnYYZAb5B6Z8sFXDQpU0NxR1DYRvwqMvpjXG5yEoXAqOrl254F99OoK3gGlJi9dx1cDu00o96vbqi9",
                {
                    stripeAccount: response.data.data.stripeAccountId,
                },
            );
            const options = {
                clientSecret: response.data.data.clientSecret,
            };

            elements.value = stripe.value.elements(options);
            const paymentElement = elements.value.create("payment");
            paymentElement.mount("#payment-element");
        })
        .catch((error) => {
            // throw error
        });
});

const handleSubmit = async (e) => {
    e.preventDefault();

    const { error } = await stripe.value.confirmPayment({
        elements: elements.value,
        redirect: "if_required",
    });

    if (error === undefined) {
        const response = await axios.post(
            route("api.payments.status.show"),
            {
                paymentIntentId: paymentIntentId.value,
            },
            {
                headers: {
                    Authorization:
                        "Bearer " + "bINIbfBAOI8YOe5wYfJcwbx58l1Clapt",
                },
            },
        );

        result.value = response.data.success;
    } else {
        errors.value = error.message;
    }
};
</script>
